import React from "react";
// import { getDeviceId } from "../utils/deviceId";

const questions = ["A7K9L2M3QX", "Z3N5B8Y1TP", "R6D4W2E9HJ", "M1Q7X5L8VA", "C9H3N2K5UB", "T4V8G6R1SD", "W7M1P4E6JQ", "K5F2R9D7LU", "H8X3C1V5ZN"];

const Home = () => {
  // const deviceId = getDeviceId();

  const resetAnswers = () => {
    Object.keys(localStorage)
      .filter((k) => k.startsWith("answered-"))
      .forEach((k) => localStorage.removeItem(k));
    localStorage.removeItem("collectedLetters");
    localStorage.removeItem("device-id");
    localStorage.removeItem("correctAnswer");
    localStorage.removeItem("solution");
    localStorage.removeItem("usedIndexes");
    localStorage.removeItem("usedLetterIds");
    localStorage.removeItem("isCorrect");
    alert("Alle Antworten wurden zurückgesetzt.");
  };

  return (
    <div className="home">
      <h1>Alle Quiz-Links individuell</h1>
      {questions.map((slug) => (
        <div className="quiz-item" key={slug}>
          <h3>Quiz {slug}</h3>
          <p>
            <a href={`/quiz/${slug}`}>Zum Quiz starten</a>
          </p>
        </div>
      ))}
      <button onClick={resetAnswers}>Quiz zurücksetzen</button>
    </div>
  );
};

export default Home;
